import { render, staticRenderFns } from "./svg-loader.vue?vue&type=template&id=0a471970&functional=true"
var script = {}
import style0 from "./svg-loader.vue?vue&type=style&index=0&id=0a471970&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports